import { makeSelectors } from '@utils/css';

const modifiers = makeSelectors({
  toggled: "dibt9disps"
});
const iconWrapper = "dibime6i3k";
const wrapper = "dibwh57ean";

export { iconWrapper, modifiers, wrapper };
import "./custom.style.linaria.module.css";
//# sourceMappingURL=custom.style.js.map
